/* External */
import { memo, useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import PropTypes from 'prop-types';

/* Languages */
import messagesEn from '../../languages/messages/en.json';
import messagesEs from '../../languages/messages/es.json';
import messagesPt from '../../languages/messages/pt.json';
import messagesPtSkyMais from '../../languages/messages/pt-skymais.json';

/* Utils */
import { Locale } from '../../utils/constants';
import { useIsBrazil } from '../ConfigProvider';
import platform from '../../utils/platform';

const messages = {
  [Locale.ES]: messagesEs,
  [Locale.EN]: messagesEn,
  [Locale.PT]: messagesPt,
  skymais: messagesPtSkyMais,
};

const Theme = {
  DGO: 'dgo',
  SKYMAIS: 'skymais',
};

let theme = import.meta.env.VITE_THEME || Theme.DGO;
if (!Object.values(Theme).includes(theme)) [theme] = Theme;

const isSkyMais = theme === Theme.SKYMAIS;

function IntlProviderWrapper({ children }) {
  const isBrazil = useIsBrazil();
  const userLanguage = isBrazil || isSkyMais ? Locale.PT : Locale.ES;
  const [timeZone, setTimeZone] = useState();

  useEffect(() => {
    async function getAndSetTimeZone() {
      const currentTimeZone = platform.isTizen ? await platform.getTimezone() || undefined
        : undefined;
      setTimeZone(currentTimeZone);
    }
    getAndSetTimeZone();
  }, []);

  return (
    <IntlProvider
      locale={userLanguage}
      messages={messages[theme] || messages[userLanguage]}
      timeZone={timeZone}
    >
      {children}
    </IntlProvider>
  );
}

IntlProviderWrapper.propTypes = {
  children: PropTypes.element.isRequired,
};

export default memo(IntlProviderWrapper);
